export const NODE_RADIUS = 100;
export const CONFIG = {RADIUS_FACTOR: 3.25};
